import { IState } from 'shared/store';

export const consultantChatIdSelector = (state: IState) => state.consultantCianChat.chatId;
